export interface GetSystemCodeKeysRequest {
  codeKey: string
  searchKey: string
  condition: GetSystemKeysCondition
}

export const GetSystemKeysCondition = {
  And: 'and',
  Or: 'or'
} as const
export type GetSystemKeysCondition = typeof GetSystemKeysCondition[keyof typeof GetSystemKeysCondition]

export function GetSystemCodeKeysRequestToJSON(
  value: GetSystemCodeKeysRequest
): any {
  return {
    code_key: value.codeKey !== '' ? value.codeKey : undefined,
    search_key: value.searchKey !== '' ? value.searchKey : '', // このプロパティだけはヴァリデーションを動作させるために常にリクエストに渡す
    condition: value.condition ? value.condition : undefined
  }
}
